<template>
    <div>
        <Navbar />
        <div class="pt-5 mt-5"></div>
        <div class="container mt-5 px-lg-5">
            <h4 class="font-weight-bolder kova-text ">How to make a programming language in C++</h4>
            <p class=" kova-light px-4" style="font-size: 18px">Making your own programming language
            </p>
            <div class="mb-4">
                <div class="row">
                    <img src="../assets/KOVATEK/IMAGES/developer-3.png" class="rounded-circle ml-3 ml-md-5" style="width: 60px; height:60px" />
                    <div class="ml-3 text-left mr-auto">
                        <p class="mt-2 mb-1 font-weight-bolder">Idris Adebowale</p>
                        <p class="kova-light mt-0" style="font-size: 12px;">June 15 * 8mins read</p>
                    </div>
                    <button class="btn-outline-kovatek px-4 mr-3" style="height: 30px">Follow </button>
                </div>
            </div>
            <div class="mb-3">
                <img src="../assets/KOVATEK/IMAGES/kovatek-web.png" class="w-100"/>
            </div>
            <div class="my-5">
                <p class="text-left">Lorem ipsum dolor sit amet consectetur adipisicing elit. Reprehenderit corporis autem repellat aperiam ducimus, odit reiciendis officiis ad sequi totam dolores temporibus voluptatum necessitatibus eius doloribus deserunt quod nobis error!</p>
                <p class="text-left">Lorem ipsum dolor sit amet consectetur adipisicing elit. Reprehenderit corporis autem repellat aperiam ducimus, odit reiciendis officiis ad sequi totam dolores temporibus voluptatum necessitatibus eius doloribus deserunt quod nobis error!</p>
                <p class="text-left">Lorem ipsum dolor sit amet consectetur adipisicing elit. Reprehenderit corporis autem repellat aperiam ducimus, odit reiciendis officiis ad sequi totam dolores temporibus voluptatum necessitatibus eius doloribus deserunt quod nobis error!</p>
                <p class="text-left">Lorem ipsum dolor sit amet consectetur adipisicing elit. Reprehenderit corporis autem repellat aperiam ducimus, odit reiciendis officiis ad sequi totam dolores temporibus voluptatum necessitatibus eius doloribus deserunt quod nobis error!</p>
                <p class="text-left">Lorem ipsum dolor sit amet consectetur adipisicing elit. Reprehenderit corporis autem repellat aperiam ducimus, odit reiciendis officiis ad sequi totam dolores temporibus voluptatum necessitatibus eius doloribus deserunt quod nobis error!</p>
                <p class="text-left">Lorem ipsum dolor sit amet consectetur adipisicing elit. Reprehenderit corporis autem repellat aperiam ducimus, odit reiciendis officiis ad sequi totam dolores temporibus voluptatum necessitatibus eius doloribus deserunt quod nobis error!</p>
                <p class="text-left">Lorem ipsum dolor sit amet consectetur adipisicing elit. Reprehenderit corporis autem repellat aperiam ducimus, odit reiciendis officiis ad sequi totam dolores temporibus voluptatum necessitatibus eius doloribus deserunt quod nobis error!</p>
                <p class="text-left">Lorem ipsum dolor sit amet consectetur adipisicing elit. Reprehenderit corporis autem repellat aperiam ducimus, odit reiciendis officiis ad sequi totam dolores temporibus voluptatum necessitatibus eius doloribus deserunt quod nobis error!</p>
                <p class="text-left">Lorem ipsum dolor sit amet consectetur adipisicing elit. Reprehenderit corporis autem repellat aperiam ducimus, odit reiciendis officiis ad sequi totam dolores temporibus voluptatum necessitatibus eius doloribus deserunt quod nobis error!</p>
                <p class="text-left">Lorem ipsum dolor sit amet consectetur adipisicing elit. Reprehenderit corporis autem repellat aperiam ducimus, odit reiciendis officiis ad sequi totam dolores temporibus voluptatum necessitatibus eius doloribus deserunt quod nobis error!</p>
                <p class="text-left">Lorem ipsum dolor sit amet consectetur adipisicing elit. Reprehenderit corporis autem repellat aperiam ducimus, odit reiciendis officiis ad sequi totam dolores temporibus voluptatum necessitatibus eius doloribus deserunt quod nobis error!</p>
            </div>
            
        </div>
        <GetHired />
        <Footer />
    </div>
</template>

<script>

import Navbar from '@/components/Navbar.vue'
import Footer from '@/components/Footer.vue'
import GetHired from '@/components/GetHired.vue'

export default {
    name: 'blog',
    components: {
        Navbar,
        Footer,
        GetHired
    }
}
</script>

<style scoped>

</style>